module.exports = __webpack_public_path__ + "img/face-smile-beam.e55db7f2.svg";